const React = require('react');
const AppIcon = require('../../../icons/Lunu');
const {
  LINK_DASHBOARD,
} = require('../../../../constants/links');
const {
  Link,
} = require('../../../../router');


module.exports = (props) => {
  return (
    <div className="fixed s ovxH ovyA ff$3 c0">
      <div className="hmin layoutRow fvaC fhaC pv50">
        <div>
          <div className="h80 layoutRow fhaC fvaE">
            <Link
              className="c0 dB olN tdN dn o70:h"
              href={LINK_DASHBOARD}
            >
              <div className="layoutRow fvaC fhaC">
                <AppIcon className="w150"/>
              </div>
              <div className="tc c5B47FF fw3 f16 lh30 lts0em mt10">
                Console
              </div>
            </Link>
          </div>
          <div className="hmin620 hmin400@x-800 pv20 ph20 break layoutRow fvaC fhaC">
            <div className="f20 fw3 mhA wmax600 ph15 tc lh">
              <div className="f100 fw7">404</div>
              <div className="mt20 f26">Page not found</div>
              <div className="mt20">
                <Link
                  className="c5B47FF olN dn f16 o70:h"
                  href={LINK_DASHBOARD}
                >
                  Go back to the main page
                </Link>
              </div>
            </div>
          </div>
          <div className="h80 layoutRow fhaC fvaS"/>
        </div>
      </div>
    </div>
  );
};
